export default function groupTransactionsByDate(transactions) {
   console.log(transactions)
   const groupedTransactions = {}

   transactions.forEach(txn => {
      const [date] = txn.createdAt.split('T')
      if (date in groupedTransactions) {
         groupedTransactions[date].push(txn)
      } else {
         groupedTransactions[date] = [txn]
      }
   })

   return groupedTransactions
}
